module.exports = __webpack_public_path__ + "img/ad1.2440ade6.png";